import { ensureJobCorn } from '@eigtech/restoration-util'
import { JobNoteFormDrawer } from '@/components/Domains/Jobs'
import { withRequiredPermissions } from '@/lib/permissions'
import { HTTPError } from '@eigtech/ui-shared-api'
import { useEntityNotes, useGetTechnicianNotebookForEntity } from '@eigtech/ui-shared-notes'
import { NotesList, NotesToolbar } from '@eigtech/ui-shared-notes-web'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/notes')({
  component: () => <JobDetailNotes />,
})

const JobDetailNotes = withRequiredPermissions(BaseJobDetailNotes, {
  requiredPermissions: { action: 'read', subject: 'note' },
})

function BaseJobDetailNotes() {
  const { jobId } = Route.useParams()

  const jobCorn = ensureJobCorn(jobId)

  const { data, isPending, isError, error } = useGetTechnicianNotebookForEntity(jobCorn)

  const is404Error = error instanceof HTTPError && error.response.status === 404

  const { isAscending, setIsAscending, query, setQuery, notes } = useEntityNotes(data, {
    defaultDataSources: 'all',
  })

  const [isNoteFormDrawerOpen, setIsNoteFormDrawerOpen] = useState(false)

  return (
    <>
      <NotesToolbar
        createNote={jobId ? () => setIsNoteFormDrawerOpen(true) : undefined}
        isAscending={isAscending}
        isError={isError}
        isPending={isPending}
        query={query}
        setIsAscending={setIsAscending}
        setQuery={setQuery}
      />

      <NotesList
        createNote={jobId ? () => setIsNoteFormDrawerOpen(true) : undefined}
        entityCorn={jobCorn}
        isAscending={isAscending}
        isError={isError && !is404Error}
        isPending={isPending}
        isSearching={!!query}
        notes={notes}
      />

      {jobId && isNoteFormDrawerOpen && (
        <JobNoteFormDrawer
          jobId={jobId}
          open={isNoteFormDrawerOpen}
          onOpenChange={setIsNoteFormDrawerOpen}
        />
      )}
    </>
  )
}
